<template>
	<div id="partner">
		<div banner>
			<div class="container">
				<div>合作伙伴</div>
			</div>
		</div>
		<div class="container" style="padding-top: 20px;">
			<div>
				<h5>证券交易所</h5>
				<ul>
					<li>深圳证交所</li>
					<li>上海证交所</li>
					<li>香港联合交易所</li>

					<li>新加坡交易所</li>
					<li>纽约证券交易所</li>
					<li>纳斯达克</li>

					<li>伦敦证券交易所</li>
					<li>伦敦AIM</li>
					<li>韩国证券交易所</li>

					<li>韩国创业板</li>
					<li>韩国证券期货交易所</li>
					<li>日本东京证券交易所</li>
				</ul>
			</div>
			<div>
				<h5>证券公司</h5>
				<ul>
					<li>中信证券</li>
					<li>华泰证券</li>
					<li>光大证券</li>
					<li>国信证券</li>

					<li>平安证券</li>
					<li>华林证券</li>
					<li>广发证券</li>
					<li>齐鲁证券</li>

					<li>安信证券</li>
					<li>宏源证券</li>
					<li>首创证券</li>
					<li>中投证券</li>

					<li>海通证券</li>
					<li>民生证券</li>
					<li>招商证券</li>
					<li>天同证券</li>

					<li>中信建投</li>
					<li>信达证券</li>
					<li>银河证券</li>
					<li>国金证券</li>

					<li>南京证券</li>
					<li>第一创业</li>
					<li>国元证券</li>
					<li>华弘证券</li>

					<li>德邦证券</li>
					<li>申银万国</li>
					<li>金信证券</li>
					<li>申银万国</li>
				</ul>
			</div>
			<div>
				<h5>行业协会</h5>
				<ul>
					<li>中国化工供销协会</li>
					<li>中国建筑卫生陶瓷协会</li>
					<li>全国工业品贸易中心联合会</li>

					<li>中国机床工具工业协会</li>
					<li>中国文房四宝协会</li>
					<li>全国城市农贸中心联合会</li>

					<li>中国机电产品流通协会</li>
					<li>中国文化办公设备行业协会</li>
					<li>全国电力技术市场协会</li>

					<li>中国机电工业价格协会</li>
					<li>中国文教体育用品协会</li>
					<li>全国商报联合会</li>

					<li>中国机电一体化技术协会</li>
					<li>中国钨业协会</li>
					<li>全国商业消防协会</li>

					<li>中国机电装备维修协会</li>
					<li>中国无机盐工业协会</li>
					<li>全国医药技术市场协会</li>

					<li>中国兵器船舶档案学会</li>
					<li>中国五金交电化工商业协会</li>
					<li>中国百货商业协会</li>

					<li>中国机械工业安全协会</li>
					<li>中国五金制品协会</li>
					<li>中国包装联合会</li>

					<li>中国机械工业标准化协会</li>
					<li>中国物流技术协会</li>
					<li>中国包装装潢印刷工业协会</li>

					<li>中国机械工业供销协会</li>
					<li>中国物流学会</li>
					<li>中国保护消费者基金会</li>

					<li>中国机械工业教育协会</li>
					<li>中国物流与采购联合会</li>
					<li>中国焙烤食品糖制品工业协会</li>

					<li>中国金属切削技术协会</li>
					<li>中国物资储运协会</li>
					<li>中国表面工程协会</li>

					<li>中国机械工业勘察协会</li>
					<li>中国物资再生协会</li>
					<li>中国玻璃钢工业协会</li>

					<li>中国机械工业联合会</li>
					<li>中国洗涤用品工业协会</li>
					<li>中国玻璃纤维工业协会</li>

					<li>中国机械工业管理协会</li>
					<li>中国香料香精化妆品协会</li>
					<li>中国仓储协会</li>

					<li>中国机械工业审计学会</li>
					<li>中国橡胶工业协会</li>
					<li>中国拆船协会</li>

					<li>中国胶粘剂工业协会</li>
					<li>中国盐业协会</li>
					<li>中国产业用纺织品行业协会</li>

					<li>中国金属材料流通协会</li>
					<li>中国眼镜协会</li>
					<li>中国锻压协会</li>

					<li>中国经济报刊协会</li>
					<li>中国药文化研究会</li>
					<li>中国发酵工业协会</li>

					<li>中国酒类流通协会</li>
					<li>中国冶金建设协会</li>
					<li>中国饭店协会</li>

					<li>中国酒类商业协会</li>
					<li>中国冶金矿山企业协会</li>
					<li>中国纺织工业企业管理协会</li>

					<li>中国旧货业协会</li>
					<li>中国液压气动密封件协会</li>
					<li>中国纺织规划研究会</li>

					<li>中国聚氨酯工业协会</li>
					<li>中国医疗器械行业协会</li>
					<li>中国纺织机械器材工业协会</li>

					<li>中国绝热隔音材料协会</li>
					<li>中国医药包装协会</li>
					<li>中国纺织勘察设计协会</li>

					<li>中国口腔清洁用品协会</li>
					<li>中国医药报刊协会</li>
					<li>中国纺织品商业协会</li>

					<li>中国乐器协会</li>
					<li>中国医药工程设计协会</li>
					<li>中国纺织摄影协会</li>

					<li>中国连锁经营协会</li>
					<li>中国医药科研开发促进会</li>
					<li>中国纺织职工思想工作研究会</li>

					<li>中国炼焦行业协会</li>
					<li>中国医药会计学会</li>
					<li>中国非处方药物协会</li>

					<li>中国磷肥工业协会</li>
					<li>中国医药教育协会</li>
					<li>中国非金属矿工业协会</li>

					<li>中国黄金协会</li>
					<li>中国玩具协会</li>
					<li>中国轮胎翻修与循环利用协会</li>

					<li>中国煤炭机械工业协会</li>
					<li>中国企业管理科学基金会</li>
					<li>中国民族贸易促进会</li>

					<li>中国煤炭加工利用协会</li>
					<li>中国企业家协会</li>
					<li>中国模板协会</li>

					<li>中国煤炭建设协会</li>
					<li>中国企业联合会</li>
					<li>中国模具工业协会</li>

					<li>中国煤炭经济研究会</li>
					<li>中国汽车工业协会</li>
					<li>中国膜工业协会</li>

					<li>中国煤炭运销协会</li>
					<li>中国汽车流通协会</li>
					<li>中国摩擦密封材料协会</li>

					<li>中国美发美容协会</li>
					<li>中国轻工机械协会</li>
					<li>中国木材流通协会</li>

					<li>中国棉纺织行业协会</li>
					<li>中国轻工企业投资发展协会</li>
					<li>中国内燃机工业协会</li>

					<li>中国民用爆破器材协会</li>
					<li>中国轻工业勘察设计协会</li>
					<li>中国耐火材料行业协会</li>

					<li>中国毛纺织行业协会</li>
					<li>中国商业网点管理联合会</li>
					<li>中国烹饪协会</li>

					<li>中国煤矿文化宣传基金会</li>
					<li>中国纯碱工业协会</li>
					<li>中国皮革协会</li>

					<li>中国煤炭发展联合促进会</li>
					<li>中国磁记录材料工业协会</li>
					<li>中国企业改革与发展研究会</li>

					<li>中国煤炭工业协会</li>
					<li>中国氮肥工业协会</li>
					<li>中国轻工业联合会</li>

					<li>中国仪器仪表行业协会</li>
					<li>中国电池工业协会</li>
					<li>中国轻工业企业管理协会</li>

					<li>中国饮料工业协会</li>
					<li>中国电力发展促进会</li>
					<li>中国轻工业史学会</li>

					<li>中国砖瓦工业协会</li>
					<li>中国电力规划设计协会</li>
					<li>中国燃料流通协会</li>

					<li>中国资源综合利用协会</li>
					<li>中国电力建设企业协会</li>
					<li>中国染料工业协会</li>

					<li>中国自行车协会</li>
					<li>中国电力企业多种经营协会</li>
					<li>中国热处理行业协会</li>

					<li>中国医药商业协会</li>
					<li>中国电力企业联合会</li>
					<li>中国人像摄影学会</li>

					<li>中国医药设备工程协会</li>
					<li>中国电石工业协会</li>
					<li>中国日用玻璃协会</li>

					<li>中国废钢铁应用协会</li>
					<li>中国机械设备成套工程协会</li>
					<li>中国日用化工协会</li>

					<li>中国缝制机械协会</li>
					<li>中国机械零部件工业协会</li>
					<li>中国日用杂品工业协会</li>

					<li>中国服装设计师协会</li>
					<li>中国机械制造工艺协会</li>
					<li>中国肉类协会</li>

					<li>中国服装协会</li>
					<li>中国基建物资承包协会</li>
					<li>中国乳制品工业协会</li>

					<li>中国氟硅有机材料协会</li>
					<li>中国集团公司促进会</li>
					<li>中国散装水泥推广发展协会</li>

					<li>中国腐植酸工业协会</li>
					<li>中国加气混凝土协会</li>
					<li>中国色织行业协会</li>

					<li>中国副食流通协会</li>
					<li>中国家具协会</li>
					<li>中国砂石协会</li>

					<li>中国钢结构协会</li>
					<li>中国家庭服务业协会</li>
					<li>中国商业股份制企业联合会</li>

					<li>中国钢铁工业协会</li>
					<li>中国家用电器商业协会</li>
					<li>中国商业会计学会</li>

					<li>中国工程爆破协会</li>
					<li>中国家用电器维修协会</li>
					<li>中国商业经济学会</li>

					<li>中国工程机械工业协会</li>
					<li>中国家用电器协会</li>
					<li>中国商业联合会</li>

					<li>中国工业合作经济学会</li>
					<li>中国家用纺织品行业协会</li>
					<li>中国商业企业管理协会</li>

					<li>中国工业合作协会</li>
					<li>中国监控化学品协会</li>
					<li>中国商业史学会</li>

					<li>中国工业经济联合会</li>
					<li>中国建材工程建设协会</li>
					<li>中国商业统计学会</li>

					<li>中国工业气体工业协会</li>
					<li>中国建材工业经济研究会</li>
					<li>中国商业文化研究会</li>

					<li>中国工艺美术协会</li>
					<li>中国建材机械工业协会</li>
					<li>中国少数民族用品协会</li>

					<li>中国罐头工业协会</li>
					<li>中国建材市场协会</li>
					<li>中国生化制药工业协会</li>

					<li>中国广告主协会</li>
					<li>中国工业玻璃协会</li>
					<li>中国石材工业协会</li>

					<li>中国合成橡胶工业协会</li>
					<li>中国建筑材料工业协会</li>
					<li>中国石灰协会</li>

					<li>中国衡器协会</li>
					<li>中国建筑材料流通协会</li>
					<li>中国石油工程建设协会</li>

					<li>中国化工安全卫生技术协会</li>
					<li>中国建筑材料企业管理协会</li>
					<li>中国石油和化工勘察设计协会</li>

					<li>中国化工防腐蚀技术协会</li>
					<li>中国建筑防水材料工业协会</li>
					<li>中国石油化工自动化应用协会</li>

					<li>中国化工防治污染技术协会</li>
					<li>中国建筑砌块协会</li>
					<li>中国石油和化学工业协会</li>

					<li>中国化工机械动力技术协会</li>
					<li>中国建筑装饰装修材料协会</li>
					<li>中国石油和石化工程研究会</li>

					<li>中国化工节能技术协会</li>
					<li>中国塑料机械工业协会</li>
					<li>中国石油化工设备工业协会</li>

					<li>中国化工企业管理协会</li>
					<li>中国塑料加工工业协会</li>
					<li>中国石油化工信息学会</li>

					<li>中国化工轻工物资流通协会</li>
					<li>中国炭素行业协会</li>
					<li>中国石油企业协会</li>

					<li>中国化工情报信息协会</li>
					<li>中国搪瓷工业协会</li>
					<li>中国食品工业协会</li>

					<li>中国化工施工企业协会</li>
					<li>中国糖业协会</li>
					<li>中国食品和包装机械工业协会</li>

					<li>中国化工装备协会</li>
					<li>中国陶瓷工业协会</li>
					<li>中国食品添加剂工业协会</li>

					<li>中国化学矿业协会</li>
					<li>中国特钢企业协会</li>
					<li>中国室内装饰协会</li>

					<li>中国化学试剂工业协会</li>
					<li>中国铁道物资流通协会</li>
					<li>中国蔬菜流通协会</li>

					<li>中国机械工业质量管理协会</li>
					<li>中国牙膏工业协会</li>
					<li>中国水利电力物资流通协会</li>

					<li>中国化学纤维工业协会</li>
					<li>中国铁合金工业协会</li>
					<li>中国水泥协会</li>

					<li>中国化学制药工业协会</li>
					<li>中国通用机械工业协会</li>
					<li>中国水泥制品工业协会</li>

					<li>中国环保机械行业协会</li>
					<li>中国涂料工业协会</li>
					<li>中国丝绸协会</li>

					<li>中国医药物资协会</li>
					<li>中国淀粉工业协会</li>
					<li>中国印染行业协会</li>

					<li>中国硫酸工业协会</li>
					<li>中国调味品协会</li>
					<li>中国印刷及设备器材工业协会</li>

					<li>中国氯碱工业协会</li>
					<li>中国酿酒工业协会</li>
					<li>中国印章行业协会</li>

					<li>中国轮胎翻修利用协会</li>
					<li>中国农药工业协会</li>
					<li>中国游艺机游乐园协会</li>

					<li>中国医药企业发展促进会</li>
					<li>中国农业机械工业协会</li>
					<li>中国友谊外供商业协会</li>

					<li>中国医药企业管理协会</li>
					<li>中国农业机械流通协会</li>
					<li>中国有色金属工业协会</li>

					<li>中国菱镁行业协会</li>
					<li>中国女企业家协会</li>
					<li>中国有色金属加工工业协会</li>

					<li>中国流通行业管理与</li>
					<li>中国拍卖行业协会</li>
					<li>中国有色金属建设协会</li>

					<li>中国中小商业企业协会</li>
					<li>中国制笔协会</li>
					<li>中国羽绒工业协会</li>

					<li>中国钟表协会</li>
					<li>中国制冷空调工业协会</li>
					<li>中国造纸化学品工业协会</li>

					<li>中国重型机械工业协会</li>
					<li>中国制药装备行业协会</li>
					<li>中国造纸协会</li>

					<li>中国轴承工业协会</li>
					<li>中国质量协会</li>
					<li>中国展览馆协会</li>

					<li>中国铸造协会</li>
					<li>中国中小企业国际合作协会</li>
					<li>中国照明电器协会</li>
				</ul>
			</div>
			<div>
				<h5>核心一级期刊</h5>
				<ul>
					<li>财贸经济</li>
					<li>半导体学报</li>
					<li>北京体育大学学报</li>
					<li>材料研究学报</li>

					<li>地球科学</li>
					<li>大学图书馆学报</li>
					<li>低温工程</li>
					<li>低温物理学报</li>

					<li>地质学报</li>
					<li>地球物理学报</li>
					<li>地震学报</li>
					<li>地质科学</li>

					<li>电子科学学刊</li>
					<li>电工技术学报</li>
					<li>电子学报</li>
					<li>电信科学</li>

					<li>动力工程</li>
					<li>动物学报</li>
					<li>法学研究</li>
					<li>分析化学</li>

					<li>复合材料学报</li>
					<li>钢铁</li>
					<li>高等工程教育研究</li>
					<li>高分子学报</li>

					<li>高能物理</li>
					<li>高校化工学报</li>
					<li>高等学校化学学报</li>
					<li>国际问题研究</li>

					<li>光电工程</li>
					<li>工程热物理学报</li>
					<li>固体力学学报</li>
					<li>管理世界</li>

					<li>国际贸易</li>
					<li>光学学报</li>
					<li>光子学报</li>
					<li>硅酸盐学报</li>

					<li>航空学报</li>
					<li>环境科学学报</li>
					<li>海洋学报</li>
					<li>海洋与湖沼</li>

					<li>化学学报</li>
					<li>红外毫米波学报</li>
					<li>化工学报</li>
					<li>化学物理学报</li>

					<li>会计研究</li>
					<li>计量学报</li>
					<li>经济研究</li>
					<li>机械工程学报</li>

					<li>计算力学学报</li>
					<li>计算机辅助设计</li>
					<li>计算机科学与技术学报</li>
					<li>教育研究</li>

					<li>计算机研究</li>
					<li>计算机学报</li>
					<li>计算数学</li>
					<li>建筑结构学报</li>

					<li>金属学报</li>
					<li>近代史研究</li>
					<li>金融研究</li>
					<li>建筑学报</li>

					<li>经济理论与管理</li>
					<li>科学学研究</li>
					<li>科学通报</li>
					<li>科研管理</li>

					<li>矿物学报</li>
					<li>空气动力学学报</li>
					<li>控制理论与应用</li>
					<li>历史研究</li>

					<li>力学学报</li>
					<li>马克思主义研究</li>
					<li>人工智能</li>
					<li>煤炭学报</li>

					<li>磨擦学学报</li>
					<li>内燃机学报</li>
					<li>内燃机工程</li>
					<li>汽车工程</li>

					<li>情报学报</li>
					<li>软件学报</li>
					<li>热力发电</li>
					<li>燃料化学学报</li>

					<li>日语学习与研究</li>
					<li>社会学研究</li>
					<li>社会科学战线</li>
					<li>水力发电学报</li>

					<li>中国生物医学报</li>
					<li>声学学报</li>
					<li>生物化学学报</li>
					<li>生物工程学报</li>

					<li>实验生物学报</li>
					<li>生物化学杂志</li>
					<li>生物物理学报</li>
					<li>生理学报</li>

					<li>数量经济研究</li>
					<li>世界经济</li>
					<li>世界历史</li>
					<li>世界宗教研究</li>

					<li>水利学报</li>
					<li>石油学报</li>
					<li>数学年刊</li>
					<li>数学学报</li>

					<li>数学进展</li>
					<li>太阳能学报</li>
					<li>体育科学</li>
					<li>天文学报</li>

					<li>通信学报</li>
					<li>土木工程学报</li>
					<li>外国文学研究</li>
					<li>外国语</li>

					<li>外语界</li>
					<li>外国文学评论</li>
					<li>外语教学与研究</li>
					<li>文学评论</li>

					<li>文艺理论研究</li>
					<li>文艺研究</li>
					<li>文艺遗产</li>
					<li>物理学报</li>

					<li>物理化学学报</li>
					<li>微波学报</li>
					<li>微生物学报</li>
					<li>无机化学学报</li>

					<li>无机材料学报</li>
					<li>现代外语</li>
					<li>系统工程理论与实践</li>
					<li>细胞生物学杂志</li>

					<li>心理学报</li>
					<li>学术月刊</li>
					<li>应用数学学报</li>
					<li>仪器仪表学报</li>

					<li>遗传学报</li>
					<li>有机化学</li>
					<li>岩土工程学报</li>
					<li>哲学研究</li>

					<li>自动化学报</li>
					<li>振动工程学报</li>
					<li>植物学报</li>
					<li>自然科学进展</li>

					<li>真空科学与技术</li>
					<li>中国物理快报</li>
					<li>植物生态学报</li>
					<li>新化文献</li>

					<li>中国高教研究</li>
					<li>中国电机工程学报</li>
					<li>中国法学</li>
					<li>中国翻译</li>

					<li>中国机械工程</li>
					<li>中国工业经济研究</li>
					<li>中国公路学报</li>
					<li>中国环境科学</li>

					<li>中国农村经济</li>
					<li>中国激光</li>
					<li>中国科学</li>
					<li>中国劳动学</li>

					<li>中国体育科技</li>
					<li>中国社会科学</li>
					<li>中共党史研究</li>
					<li>中国史研究</li>

					<li>中国有色金属报</li>
					<li>中国图书馆学报</li>
					<li>政治学研究</li>
					<li>中国音乐学</li>

					<li>中华医学杂志</li>
					<li>中国语文</li>
					<li>中华放射学杂志</li>
					<li>中华心血管病杂志</li>

					<li>自然辩证法研究</li>
					<li>中央音乐学院学报</li>
				</ul>
			</div>
			<div>
				<h5>网络媒体</h5>
				<ul>
					<li>
						<a href="http://www.chinajob.com/" target="_blank">Chinajob</a>
					</li>
					<li>
						<a href="http://www.21food.com/" target="_blank">21Food</a>
					</li>
					<li>
						<a href="http://www.export.by/" target="_blank">EXPORT.BY</a>
					</li>

					<li>
						<a href="http://english.enorth.com.cn/" target="_blank">Enorth</a>
					</li>
					<li>
						<a href="http://www.analysys.com.cn" target="_blank">Analysys International</a>
					</li>
					<li>
						<a href="http://www.iresearch.com.cn/" target="_blank">iResearch</a>
					</li>

					<li>
						<a href="http://www.byna.cn/" target="_blank">BYNA Telecom Consulting</a>
					</li>
					<li>
						<a href="http://www.fpdisplay.com/" target="_blank">FPDisplay</a>
					</li>
					<li>
						<a href="http://www.ccwresearch.com.cn/" target="_blank">CCWResearch</a>
					</li>

					<li>
						<a href="http://www.ndcchina.com.cn/" target="_blank">NuodaConsulting</a>
					</li>
					<li>
						<a href="http://www.bjreview.com.cn/" target="_blank">BJReview</a>
					</li>
					<li>
						<a href="http://www.b2bface.com/" target="_blank">B2Bface</a>
					</li>

					<li>
						<a href="http://www.hichem.com/" target="_blank">HiChem</a>
					</li>
					<li>
						<a href="http://www.vinniesworld.com/" target="_blank">Vinnie's World</a>
					</li>
					<li>
						<a href="http://en.tibet.cn/" target="_blank">TIBET</a>
					</li>

					<li>
						<a href="http://www.timesfirst.com/free-b2b.aspx" target="_blank">Free B2B</a>
					</li>
					<li>
						<a href="http://www.titaniummetalsupply.com/" target="_blank">Titanium</a>
					</li>
					<li>
						<a
							href="http://www.buysingapore.com/biztype/business.html"
							target="_blank"
						>Import export trade leads</a>
					</li>

					<li>
						<a href="http://www.hisupplier.com/" target="_blank">HiSupplier China Supplier Directory</a>
					</li>
					<li>
						<a href="http://www.bj-realestate.com/" target="_blank">Beijing Real Estate</a>
					</li>
					<li>
						<a href="http://www.macraesbluebook.com/" target="_blank">MacRAE's Blue Book</a>
					</li>

					<li>
						<a href="http://english.cisregister.com/" target="_blank">China Industrial Supply Register</a>
					</li>
					<li>
						<a href="http://en.purchasingbbs.com/" target="_blank">China Purchasing Forum</a>
					</li>
					<li>
						<a href="http://www.excellaw.co.uk/" target="_blank">Car Accident Claim</a>
					</li>

					<li>
						<a href="http://www.excellaw.co.uk/" target="_blank">Learn Chinese</a>
					</li>
					<li>
						<a href="http://www.trader-china.com/" target="_blank">Trade China</a>
					</li>
					<li>
						<a href="http://www.stream-max.com/" target="_blank">Manufacturing China</a>
					</li>

					<li>
						<a href="http://www.stream-max.com/" target="_blank">China Travel Service</a>
					</li>
					<li>
						<a href="http://www.chinatour360.com/" target="_blank">China Tour</a>
					</li>
					<li>
						<a href="http://www.ffcrafts.com/" target="_blank">FFcrafts</a>
					</li>

					<li>
						<a href="http://www.afrotrade.net/" target="_blank">AFROTRADE - Online &amp; Print Media</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	export default {

	}
</script>
